import React from "react";
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import { TextField } from '@material-ui/core';
import { withRouter } from "react-router";
import moment from 'moment'
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress'
import MuiAlert from '@material-ui/lab/Alert';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import { } from "pages/redux/actions";
import axios from 'axios';
import ReactDatetime from "react-datetime";
import { connect } from 'react-redux';
import { useHistory,Link } from "react-router-dom";
import Autocomplete from '@material-ui/lab/Autocomplete';
// reactstrap components
import { Button, Card, CardHeader, CardFooter, CardBody, FormGroup, Form, Modal, Input, Container, InputGroup, Row, Col,} from "reactstrap";
// core components
import UserHeader from "components/Headers/UserHeader.js";
import { makeStyles } from "@material-ui/core/styles";


const getMuiTheme = () =>
    createMuiTheme({
        overrides: {
            MuiTextField: {
                root: {
                    backgroundColor: '#fff',
                    width: '100%',
                    borderRadius: '5px',
                    border: '0px',
                    '&:hover': {
                        outline: '0',
                    },
                    '& label.Mui-focused': {
                        color: '#7c8892',
                    },
                    '& .MuiInput-underline:after': {
                        borderBottomColor: '#7c8892',
                    },
                    '& .MuiOutlinedInput-root': {
                        height: '45px',
                        '& fieldset': {
                            borderColor: '#e8ecef',
                            borderRadius: '5px',
                            border: '1px',
                            paddingTop: '0px',
                            boxShadow: '0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02)',
                        },
                        '&:hover fieldset': {
                            borderColor: '#Dbe0e5',
                            border: '1px',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#',
                            border: '1px',
                            boxShadow: '0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)',
                        },
                    },
                    '& .MuiInputLabel-root': {
                        fontSize: 14,
                    },
                    '& .MuiInputLabel-shrink': {
                        marginTop: '-7px',
                        marginLeft: '-13px',
                        fontSize: 16,
                        color: 'black'
                    },
                    '& .MuiFormLabel-root': {
                        color: '#a6afb7',
                        lineHeight: 0.5,
                    }
                }
            }
        },
    });

    const useStyles2 = makeStyles((theme) => ({
        dark: {
            fontSize: 15,
            color: '#8898aa',
            marginTop: '1px',
            padding: '13px 12px'
        },
        white: {
            fontSize: 15,
            color: "#8898aa",
            marginTop: '1px',
            padding: '13px 12px'
        },
    }));


const Profile = (props) => {
    // const location = useLocation();

    const useStyles = makeStyles((theme) => ({
        root: {
            backgroundColor: 'green',
            "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
                transform: "translate(14px, 20px) scale(1);",
                backgroundColor: '',
            },
            "& .MuiTextField": {
                root: {
                    backgroundColor: 'pink'
                }
            },
        },
        inputRoot: {
            color: "#a3a9b2",
            height: '42px',
            boxShadow: '0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02)',
            fontSize: '15px',
            marginLeft: '0px',
            paddingTop: '15px !important',
            paddingLeft: '10px !important',
            '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
                paddingLeft: '0px !important',
                paddingTop: '0px !important',
                marginLeft: '0px',
                marginTop: '0px'
            },
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent"
            },
            "& .MuiTextField-root": {
            },
            "& .MuiChip-root": {
                backgroundColor: '',
                marginTop: '-15px !important',
                marginLeft: '0px !important',
                paddingTop: '0px !important',
                paddingLeft: '0px !important'
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent"
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
                // boxShadow: 'none',
                boxShadow: '0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)',
            },
            "&.MuiInputBase-inputAdornedEnd .MuiOutlinedInput-inputAdornedEnd": {
                paddingTop: '0px !important'
            }
        },
        listbox: {
            backgroundColor: 'transparent',
            marginTop: '0px',
            outline: '0',
            color: "#a3a9b2",
            borderBottom: 'none',
            paddingTop: '0px',
            paddingBottom: '0px',
        },
        paper: {
            backgroundColor: 'transparent'
        },
        clearIndicator: {
            color: "#a3a9b2",
            disableRipple: true,
        },
        popupIndicator: {
            color: "#a3a9b2",
            disableRipple: true,
        },
        option: {
            backgroundColor: (props.theme === 'white' ? '#fff' : (props.theme === 'dark' ? '#000' : '#16141f')),
            padding: '8px 8px',
            "&:hover": {
                backgroundColor: (props.theme === 'white' ? '#f5f5f5' : (props.theme === 'dark' ? '#121212' : '#201e2b'))
            },
            "&.Mui-focused": {
                backgroundColor: 'yellow'
            },
        },
        '@global': {
            '.MuiAutocomplete-option[data-focus="true"]': {
                backgroundColor: (props.theme === 'white' ? '#f5f5f5' : (props.theme === 'dark' ? '#121212' : '#201e2b'))
            }
        }
    }));

    // const hiddenFileInput = React.useRef(null);
    const classes = useStyles();
    const classes2 = useStyles2();
    const history = useHistory();
    const [sendingdata, setSendingdata] = React.useState('');
    const [tt, settt] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [curid, setCurid] = React.useState();
    const [change, setchange] = React.useState({ user: props.username });
    // const [filename, setfilename] = React.useState('Choose a file');
    const [responseData, setResponseData] = React.useState([]);
    const [responseData2, setResponseData2] = React.useState([]);
    const [responseDatab, setResponseData1] = React.useState([]);
    const [editcontent, seteditcontent] = React.useState('Add');
    const [dcontent, setdcontent] = React.useState(false);
    const [calender, setcalender] = React.useState(false);
    const fetchData = React.useCallback(() => {
        // console.log('fetching')
        axios.get(process.env.REACT_APP_DOMAIN+"/latestevent", { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                setCurid(response.data.id)
                // console.log(curid)
            })
            .catch((error) => {
                setSendingdata('Something went wrong, Please Try Again')
                settt('error')
                setOpen(true);
            })
        axios.get(process.env.REACT_APP_DOMAIN+"/accounts", { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                setResponseData(response.data)
            })
            .catch((error) => {
                setSendingdata('Something went wrong')
                settt('error')
                setOpen(true);
            })
        axios.get(process.env.REACT_APP_DOMAIN+"/admins", { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                setResponseData2(response.data)
            })
            .catch((error) => {
                setSendingdata('Something went wrong')
                settt('error')
                setOpen(true);
            })
        axios.get(process.env.REACT_APP_DOMAIN+"/events", { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                setResponseData1(response.data)
                // console.log(response.data)
                // console.log(responseDatab)
            })
            .catch((error) => {
                setSendingdata('Something went wrong')
                settt('error')
                setOpen(true)
            })
    }, [props.token])
    React.useEffect(() => {
        fetchData()
        document.title = "Add Event - Depact"
    }, [fetchData])
    // console.log(props)
    const dataBuyer2 = []
    if(responseDatab){
        responseDatab.map(function (responseDatab, index) {
            var tfrom = moment(responseDatab.tfrom, "HH:mm:ss").format("hh:mm A")
            var tto = moment(responseDatab.tto, "HH:mm:ss").format("hh:mm A")
            // console.log(tfrom)
            dataBuyer2.push({
                'title': responseDatab.title, 'date': responseDatab.date,'desc': responseDatab.description,'time': tfrom + ' - '+tto,'eid': responseDatab.id
            })
            return(null)
        })
    }
    // console.log(dataBuyer2)
    const data2 = []
    if(responseData){
        responseData.map(function (responseData, index) {
            var fullname = responseData.first_name + ' ' + responseData.last_name
            data2.push({ id: responseData.id, title: responseData.username, Name: fullname, Email: responseData.email })
            return(null)
        })
    }

    const data3 = []
    if(responseData2){
        responseData2.map(function (responseData2, index) {
            var fullname = responseData2.first_name + ' ' + responseData2.last_name;
            data3.push({ id: responseData2.id, title: responseData2.username, Name: fullname, Email: responseData2.email })
            return(null)
        })
    }

    const handleClose = (event, reason) => {
        setOpen(false);
    };

    const handleChange = (event) => {
        setchange({...change,[event.target.name]: event.target.value})
        // console.log(change)
    };

    const handleChangeED = (event) => {
        // console.log(event._d)
        var right = moment(event._d).format("YYYY-MM-DD")
        // console.log(right)
        setchange({ ...change, date: right })
    };

    const handleChangeTF = (event) => {
        // console.log(event._d)
        var right = moment(event._d).format("HH:mm")
        // console.log(right)
        setchange({ ...change, timef: right })
    };

    const handleChangeTT = (event) => {
        // console.log(event._d)
        var right = moment(event._d).format("HH:mm")
        // console.log(right)
        setchange({ ...change, timet: right })
    };

    const handleCloseCal = (event) => {
        setcalender(false)
    };

    const handleChangeRF = (event) => {
        // console.log(event._d)
        var right = moment(event._d).format("YYYY-MM-DD")
        // console.log(right)
        setchange({ ...change, regf: right })
    }

    const handleChangeRT = (event) => {
        // console.log(event._d)
        var right = moment(event._d).format("YYYY-MM-DD")
        // console.log(right)
        setchange({ ...change, regt: right })
    }

    const handleChangeT = (event, value) => {
        // console.log(event)
        // console.log(value)
        setchange({ ...change, tags: value })
        // if (value === null) {
        //     setchange({ ...change, buyer: undefined })
        // }
        // else {
        //     setchange({ ...change, buyer: value.id })
        // }
    };

    const handleEventClick=(e)=> {
        // var pid = e.event.extendedProps.eid
        // history.push('/main/event/'+pid)
    }


    const handleChangeEdit = () => {
        if (editcontent === 'Add') {
            seteditcontent(<CircularProgress size="20px" className={"textb-" + props.theme} />)
            setdcontent(true)
            // console.log(change)
            if ((change.name === undefined) || (change.etype === undefined) || (change.date === undefined) || (change.timef === undefined) || (change.timet === undefined)){
                setSendingdata('Please add main details properly')
                settt('error')
                setOpen(true)
                seteditcontent('Add')
                setdcontent(false)
                return 0;
            }
            axios.post(process.env.REACT_APP_DOMAIN+'/add-event', change, { 'headers': { 'Authorization': 'Token ' + props.token } })
                .then((response) => {
                    // console.log(response.data)
                    props.fetch()
                    history.push({
                        pathname: '/super-admin/add-poster',
                        state: {
                            "token": 1,
                            "id": response.data.id,
                            "message": 'Successfully Added Event',
                            'type': 'success'
                        }
                    })
                })
                .catch((error) => {
                    console.log(error)
                    setOpen(true)
                    setSendingdata('Something went wrong')
                    settt('error')
                    seteditcontent('Add')
                    setdcontent(false)
                })
        }
        else {
            seteditcontent('Add')
            setdcontent(false)
        }
    };

    return (
        <>
            <UserHeader id={props.username} />
            {/* Page content */}
            <Container className="mt--7" fluid>
                <Row>
                    <Col className="order-xl-1" xl="12">
                        <Card className={"shadow cardbg-" + props.theme}>
                            <CardHeader className={"border-0 cardbg-" + props.theme}>
                                <Row className="align-items-center">
                                    <Col xs="8">
                                        <h3 className={"mb-0 textb-"+props.theme}>Event</h3>
                                    </Col>
                                    <Col className="text-right" xs="4">
                                            <Button
                                                color="secondary"
                                                outline
                                                onClick={(e) => setcalender(!calender)}
                                            >
                                                Calender
                                        </Button>
                                        {/* }
                                        {edit &&
                                        } */}
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody className="pb-0">
                                <Form>


                                    <h6 className="heading-small text-muted mb-4">Main Details</h6>


                                    <div className="">
                                        <Row className="pt-3">
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Event ID" variant="outlined" className={"inputbg-" + props.theme} value={curid} name="id" autoComplete="off"
                                                            InputLabelProps={{shrink: true}}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Event Name" variant="outlined" className={"inputbg-"+props.theme} name="name" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} 
                                                            />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <Input className={"form-control-alternative inputbg-" + props.theme} id="input-cno" name="status" onChange={handleChange} placeholder="Event Status" type="select" defaultValue="c">
                                                        <option value="c" disabled>Select Event Status</option>
                                                        <option value="Pending">Pending</option>
                                                        <option value="Ongoing">Ongoing</option>
                                                        <option value="Confirmed">Confirmed</option>
                                                        <option value="Finished">Finished</option>
                                                        <option value="Cancelled">Cancelled</option>
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <Input className={"form-control-alternative inputbg-" + props.theme} id="input-cno" name="etype" onChange={handleChange} placeholder="Event Type" type="select" defaultValue="c">
                                                        <option value="c" disabled>Select Event Type</option>
                                                        <option value="Workshop">Workshop</option>
                                                        <option value="Seminar">Seminar</option>
                                                        <option value="Webinar">Webinar</option>
                                                        <option value="Competition">Competition</option>
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <Input className={"form-control-alternative inputbg-" + props.theme} id="input-cno" name="target" onChange={handleChange} placeholder="Event Name" type="select" defaultValue="c">
                                                        <option value="c" disabled>Select Event Target</option>
                                                        <option value="Students">Students</option>
                                                        <option value="Faculty">Faculty</option>
                                                        <option value="All">All</option>
                                                        {/* <option value="Cancelled">Cancelled</option> */}
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <InputGroup className={"input-group-alternative inputbg-"+props.theme}>
                                                        <ReactDatetime className={"text-left inputbg-" + props.theme} name="date" timeFormat={false} showClearButton={true} inputProps={{ placeholder: "Event Date",className: 'form-control form-control-alternative inputbg-'+props.theme }} onChange={handleChangeED} dateFormat="Do MMM YYYY" />
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <InputGroup className={"input-group-alternative inputbg-" + props.theme}>
                                                        <ReactDatetime className={"text-left inputbg-" + props.theme} name="tfrom" dateFormat={false} initialViewMode="time" inputProps={{ placeholder: "Event Time From", className: 'form-control form-control-alternative inputbg-' + props.theme }} onChange={handleChangeTF}/>
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <InputGroup className={"input-group-alternative inputbg-" + props.theme}>
                                                        <ReactDatetime className={"text-left inputbg-" + props.theme} name="tto" dateFormat={false} initialViewMode="time" inputProps={{ placeholder: "Event Time To", className: 'form-control form-control-alternative inputbg-' + props.theme }} onChange={handleChangeTT}/>
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>

                                    <h6 className="heading-small text-muted mb-4 mt-3">Presenter Details</h6>


                                    <div className="">
                                        <Row className="pt-3">
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Presenter Name" variant="outlined" className={"inputbg-" + props.theme} name="presentern" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ?  classes2.white :classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Presenter Designation" variant="outlined" className={"inputbg-" + props.theme} name="presenterd" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Presenter Company" variant="outlined" className={"inputbg-" + props.theme} name="presenterc" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Presenter Contact" variant="outlined" className={"inputbg-" + props.theme} name="presentercon" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>

                                    <h6 className="heading-small text-muted mb-4 mt-3">Organizer Details</h6>


                                    <div className="">
                                        <Row className="pt-3">
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Organizing Committee" variant="outlined" className={"inputbg-" + props.theme} name="organizer" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Faculty Co-ordinator" variant="outlined" className={"inputbg-" + props.theme} name="faccod1" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Faculty Co-ordinator" variant="outlined" className={"inputbg-" + props.theme} name="faccod2" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Faculty Co-ordinator" variant="outlined" className={"inputbg-" + props.theme} name="faccod3" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Convener" variant="outlined" className={"inputbg-" + props.theme} name="con1" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Convener" variant="outlined" className={"inputbg-" + props.theme} name="con2" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Student Co-ordinator" variant="outlined" className={"inputbg-" + props.theme} name="student1" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Student Co-ordinator" variant="outlined" className={"inputbg-" + props.theme} name="student2" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>

                                    <h6 className="heading-small text-muted mb-4 mt-3">Registration Details</h6>


                                    <div className="">
                                        <Row className="pt-3">
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Registration Link" variant="outlined" className={"inputbg-" + props.theme} name="reglink" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <FormGroup>
                                                        <InputGroup className={"input-group-alternative inputbg-" + props.theme}>
                                                            <ReactDatetime className={"text-left inputbg-" + props.theme} name="regf" timeFormat={false} inputProps={{ placeholder: "Registration From", className: 'form-control form-control-alternative inputbg-' + props.theme }} onChange={handleChangeRF}/>
                                                        </InputGroup>
                                                    </FormGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <FormGroup>
                                                        <InputGroup className={"input-group-alternative inputbg-" + props.theme}>
                                                            <ReactDatetime className={"text-left inputbg-" + props.theme} name="regt" timeFormat={false} inputProps={{ placeholder: "Registration To", className: 'form-control form-control-alternative inputbg-' + props.theme }} onChange={handleChangeRT}/>
                                                        </InputGroup>
                                                    </FormGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Meeting Link" variant="outlined" className={"inputbg-" + props.theme} name="mlink" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>

                                    <h6 className="heading-small text-muted mb-4 mt-3">Extra Details</h6>


                                    <div className="">
                                        <Row className="pt-3">
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Event Perks" variant="outlined" className={"inputbg-" + props.theme} name="perks" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField label="Event Description" variant="outlined" className={"inputbg-" + props.theme} name="desc" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="6" xl="6" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <Autocomplete
                                                            multiple
                                                            limitTags={2}
                                                            id="multiple-limit-tags"
                                                            options={data3}
                                                            classes={classes} 
                                                            className={"inputbg-" + props.theme}
                                                            onChange={handleChangeT}
                                                            getOptionLabel={(option) => option.title}
                                                            getOptionSelected={(option, value) => option.id === value.id}
                                                            renderInput={(params) => <div><TextField {...params} label="Select Tags" style={{ height: '45px', color: '#a3a9b2', marginLeft: '0px',backgroundColor: 'transparent' }} name="tags" className="form-control-alternative" variant="outlined" /></div>}
                                                        />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                </Form>
                                <Modal
                                    size="lg"
                                    className="modal-dialog-centered pl-4 pr-4 pt-4 pb-4"
                                    isOpen={calender}
                                    toggle={handleCloseCal}>
                                    <div className="modal-header">
                                        <h2 className="modal-title mt-2 mb-0" id="modal-title-default"> Calender</h2>
                                        <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={handleCloseCal}> <span aria-hidden={true}>×</span> </button>

                                    </div>
                                    <div className="pl-3 pr-3 pt-3 pb-3" style={{height: '650px'}}>
                                        <FullCalendar
                                            plugins={[dayGridPlugin]}
                                            initialView="dayGridMonth"
                                            events={dataBuyer2}
                                            eventContent={renderEventContent}
                                            eventClick={handleEventClick}
                                        />
                                    </div>
                                </Modal>
                            </CardBody>
                            <CardFooter className={"cardbg-"+props.theme}>
                                <div className="text-center">
                                    <Button
                                        color="info"
                                        outline
                                        disabled={dcontent}
                                        onClick={handleChangeEdit}
                                    >
                                        {editcontent}
                                    </Button>
                                </div>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                    <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
                </Snackbar>
            </Container>
        </>
    );
};


function renderEventContent(e) {
    // console.log(e)
    console.log(e)
    return (
        <>
        <Link className='text-white event-calender' to={'/main/event/'+e.event.extendedProps.eid}>
        <div style={{backgroundColor: '',border: 0,whiteSpace: 'nowrap',textOverflow: 'ellipsis',overflow: 'hidden'}}>
            <p style={{wordWrap: 'break-word',wordBreak: 'break-all'}}>{e.event.title}</p>
            <i style={{}}>( {e.event.extendedProps.time}</i></div></Link>
        </>
    )
}

Profile.propTypes = {
    fetch: PropTypes.func.isRequired
};

export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        theme: state.theme,
        text: state.text,
        token: state.token,
    }
}

export default withRouter(connect(mapStateToProps)(Profile));
